const currencyFormatter = new Intl.NumberFormat('de')

export function formatCurrency(value?: number) {
  return value != null
    ? currencyFormatter.format(value)
    : undefined
}
